import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import CustomCreator from './CustomCreator';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <CustomCreator />
  </React.StrictMode>
);